import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { oddsApi } from "../constant";

export const activeMatchesApi = createApi({
  reducerPath: "activeMatchesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: oddsApi || import.meta.env.VITE_BASE_URL || "http://localhost:3001",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (build) => ({
    activeMatch: build.query({
      query: (args) => {
        return {
          // url: `/betfair_api/active_match/${args}`,
          url: `/betfair_api/active_match/v5/${args}`,
          method: "GET",
        }
      },
    }),
    getMyIp: build.query({
      query: (args) => {
        return {
          url: `/betfair_api/my-ip`,
          method: "GET",
        }
      },
    })
  }),
});

export const {useActiveMatchQuery, useGetMyIpQuery} = activeMatchesApi;
